import React, { useState, useRef } from "react";

import { FontAwesomeIcon }
from "@fortawesome/react-fontawesome";

import
{
    faFileLines,
    faFolderOpen,
    faCalendarDays,
    faFile,
    faXmark
}
from "@fortawesome/free-solid-svg-icons";

import { OMNISCAN_BLUE }
from "../../../constants/colors";

export default function FolderForagerDocumentPopup(
{
    document,
    onClose,
	openDocumentUrl
})
{
    const [position, setPosition] = useState({
        x: window.innerWidth - 360,
        y: 170
    });

    const dragging = useRef(false);

    const dragOffset = useRef({
        x:0,
        y:0
    });
	
	
	const labelCell =
	{
	    width:"90px",

	    padding:"7px 0",

	    fontWeight:600,

	    fontSize:"12px",

	    color:"#666",

	    borderBottom:"1px solid rgba(0,0,0,.08)"
	};

	const valueCell =
	{
	    padding:"7px 0",

	    fontSize:"12px",

	    color:"#333",

	    borderBottom:"1px solid rgba(0,0,0,.08)"
	};

    function mouseDown(e)
    {
        dragging.current = true;

        dragOffset.current =
        {
            x:e.clientX-position.x,
            y:e.clientY-position.y
        };

        window.document.addEventListener(
            "mousemove",
            mouseMove
        );

        window.document.addEventListener(
            "mouseup",
            mouseUp
        );
    }

    function mouseMove(e)
    {
        if(!dragging.current)
            return;

        setPosition({
            x:e.clientX-dragOffset.current.x,
            y:e.clientY-dragOffset.current.y
        });
    }

    function mouseUp()
    {
        dragging.current=false;

        window.document.removeEventListener(
            "mousemove",
            mouseMove
        );

        window.document.removeEventListener(
            "mouseup",
            mouseUp
        );
    }

    if(!document)
        return null;

    return(

        <div

            style={{

                position:"fixed",

                left:position.x,

                top:position.y,

                width:"320px",

                background:"rgba(255,255,255,.22)",

                backdropFilter:"blur(18px)",
                WebkitBackdropFilter:"blur(18px)",

                border:"1px solid rgba(255,255,255,.30)",

                borderRadius:"20px",

                boxShadow:
                    "0 18px 45px rgba(0,0,0,.22)",

                overflow:"hidden",

                zIndex:470

            }}

        >

            {/* Header */}

            <div

                onMouseDown={mouseDown}

                style={{

                    display:"flex",

                    justifyContent:"space-between",

                    alignItems:"center",

                    padding:"14px 18px",

                    cursor:"move",

                    userSelect:"none",

                    borderBottom:
                        "1px solid rgba(255,255,255,.20)"

                }}

            >

                <div
                    style={{

                        display:"flex",

                        alignItems:"center",

                        gap:"10px"

                    }}
                >

                    <FontAwesomeIcon

                        icon={faFileLines}

                        style={{

                            color:OMNISCAN_BLUE

                        }}

                    />

                    <div
                        style={{

                            fontWeight:600,

                            fontSize:"14px"

                        }}
                    >

                        Document

                    </div>

                </div>

                <FontAwesomeIcon

                    icon={faXmark}

                    onClick={onClose}

                    style={{

                        cursor:"pointer",

                        color:"#666"

                    }}

                />

            </div>

            {/* Content */}

            <div
                style={{
                    padding:"18px"
                }}
            >

                <div
                    style={{
                        fontSize:"14px",
                        fontWeight:600,
                        marginBottom:"18px",
                        wordBreak:"break-word"
                    }}
                >

                    {document.title}

                </div>

				<table
				    style={{
				        width: "100%",
				        borderCollapse: "collapse",
				        marginTop: "12px",
				        marginBottom: "18px",
				        fontSize: "12px"
				    }}
				>

				    <tbody>

				        <tr>
				            <td style={labelCell}>Type</td>
				            <td style={valueCell}>{document.extension}</td>
				        </tr>

				        <tr>
				            <td style={labelCell}>Folder</td>
				            <td style={valueCell}>{document.directoryName}</td>
				        </tr>

				        <tr>
				            <td style={labelCell}>Modified</td>
				            <td style={valueCell}>{document.documentDate}</td>
				        </tr>

				        <tr>
				            <td style={labelCell}>Size</td>
				            <td style={valueCell}>{document.size}</td>
				        </tr>

				    </tbody>

				</table>

                <div
                    style={{
                        marginTop:"24px",
                        borderTop:"1px solid rgba(255,255,255,.20)",
                        paddingTop:"18px"
                    }}
                >

                    <div
                        style={{
                            fontWeight:700,
                            marginBottom:"8px",
							fontSize:'14px',
							background:
							'rgba(255,255,255,.18)',
							borderRadius:'12px',
							padding:'12px'
                        }}
                    >

                        AI Summary

                    </div>

                    <div
                        style={{
                            fontSize:"13px",
                            color:"#555",
                            lineHeight:1.5
                        }}
                    >

                        No summary available.

                    </div>

                </div>

            </div>
			<div
			    style={{
			        marginTop:"18px",
			        paddingTop:"14px",
			        borderTop:"1px solid rgba(0,0,0,.08)",
			        textAlign:"center",
					paddingBottom:'20px',
			    }}
			>

			    <a

			        href={openDocumentUrl}

			        target="_blank"

			        rel="noopener noreferrer"

			        style={{

			            color:OMNISCAN_BLUE,

			            textDecoration:"none",

			            fontSize:"12px",

			            fontWeight:600,
						textDecoration:'underline',
						cursor:'pointer'

			        }}

			    >

			        Open in new window

			    </a>

			</div>
        </div>

    );

}

function InfoRow(
{
    icon,
    title,
    value
})
{
    return(

        <div

            style={{

                display:"flex",

                alignItems:"center",

                marginBottom:"12px"

            }}

        >

            <FontAwesomeIcon

                icon={icon}

                style={{

                    width:"20px",

                    color:OMNISCAN_BLUE

                }}

            />

            <div
                style={{
                    width:"80px",
                    fontWeight:600,
                    color:"#555"
                }}
            >

                {title}

            </div>

            <div
                style={{
                    flex:1
                }}
            >

                {value}

            </div>

        </div>

    );

}